module.exports = __webpack_public_path__ + "img/css.60eecb1b.png";